import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.css']
})
export class PasswordResetComponent implements OnInit {
  private email: string;
  private emailSendt: boolean;
  constructor(
    private userService: UserService
  ) { }

  ngOnInit() {
  }

  sendResetPasswordEmail(){
    this.userService.sendResetPasswordEmail(this.email)
    .then((response)=>{
      console.log(response)
      this.emailSendt = true;
    },(message)=>{
      console.log(message)
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/guest/password-reset/password-reset.component.ts